import { useCondoContext } from '@/features/auth/use-condo-context';
import { PaquetesConserjeView } from './conserje-view';
import { PaquetesResidenteView } from './residente-view';

export function PaquetesRoute() {
  const { rol } = useCondoContext();

  if (
    rol === 'super_admin' ||
    rol === 'admin' ||
    rol === 'conserje' ||
    rol === 'comite'
  ) {
    return <PaquetesConserjeView />;
  }

  return <PaquetesResidenteView />;
}
